import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';

function Jumbotron() {
    const {data : {about: {jumbotron : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="hero">
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-lg-5">
                        <div className="intro-excerpt">
                            <h1>
                                {name}
                            </h1>
                            <p className="mb-4">
                                {caption}
                            </p>
                            <p>
                                {data.btn_button1 && <a href={data.btn_button1.key} className="btn btn-white-outline">{data.btn_button1.value}</a>}
                                {data.btn_button2 && <a href={data.btn_button2.key} className="btn btn-secondary me-2">{data.btn_button2.value}</a>}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="hero-img-wrap">
                            <img src={data.img_featured} className="img-fluid" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Jumbotron;